import PlayHeadTracker from 'video-js-core/src/events/PlayHeadTracker';

/**
 * Trigger quartile reached events on playback.
 * @param {videojs} player
 * @param {object} playHeadTracker
 * @param {integer} quartile
 */
function handleQuartile(player, playHeadTracker, q) {
  const playbackStarted = Math.floor(playHeadTracker.currentTime) > 0;
  const percentagePlayed = 100 * (playHeadTracker.currentTime / playHeadTracker.duration);
  const reached = Math.round(percentagePlayed) >= 100 * (q / 4) && playbackStarted;

  // If the percentage of played video time is greater than the quartile percentage defined
  // by the 'q' parameter and a player event has not yet been been fired for this quartile,
  // then trigger a player quaratile event and set the quartile as reached.
  if (!playHeadTracker.getQuartileReached(q) && reached) {
    playHeadTracker.setQuartileReached(q, true);
    player.trigger(`played-q${q}`);
  }
}

/**
 * Clear reached quartiles on seek.
 * @param {object} playHeadTracker
 * @param {integer} quartile
 */
function handleSeek(playHeadTracker, q) {
  const playbackStarted = Math.floor(playHeadTracker.currentTime) > 0;
  const percentagePlayed = 100 * (playHeadTracker.currentTime / playHeadTracker.duration);
  const reached = Math.round(percentagePlayed) >= 100 * (q / 4) && playbackStarted;

  // If the percentage of played video time is less than the quartile percentage defined
  // by the 'q' parameter and a player event has already been been fired for this quartile,
  // then set the quartile as not reached.
  if (playHeadTracker.getQuartileReached(q) && !reached) {
    playHeadTracker.setQuartileReached(q, false);
  }
}

/**
 * 'timeupdate' event handler.
 * @param {object} playHeadTracker
 */
export function timeUpdateHandler(playHeadTracker) {
  // Reset the duration if we don't have one yet. It's important to not check
  // for 0, as during the ad break this will be `NaN` instead of `0`
  if (!playHeadTracker.duration) {
    playHeadTracker.setDuration(this.duration());
  }

  // Register elapsed video playback time.
  playHeadTracker.setCurrentTime(this.currentTime());

  // Check if any quartiles have been reached and trigger events accordingly.
  handleQuartile(this, playHeadTracker, 0);
  handleQuartile(this, playHeadTracker, 1);
  handleQuartile(this, playHeadTracker, 2);
  handleQuartile(this, playHeadTracker, 3);
  handleQuartile(this, playHeadTracker, 4);
}

/**
 * 'seeked' event handler.
 * @param {object} playHeadTracker
 */
export function seekedHandler(playHeadTracker) {
  // Register elapsed video playback time.
  playHeadTracker.setCurrentTime(this.currentTime());

  // Check if user has seeked and invalidated any reached quartiles.
  handleSeek(playHeadTracker, 0);
  handleSeek(playHeadTracker, 1);
  handleSeek(playHeadTracker, 2);
  handleSeek(playHeadTracker, 3);
  handleSeek(playHeadTracker, 4);
}

/**
 * Clear tracker data, used on 'ended' and 'loadedmetadata' events.
 * @param {object} playHeadTracker
 */
export function clearPlayHeadTracker(playHeadTracker) {
  playHeadTracker.clear();
}

/**
 * Register player quartile played events.
 * @param {videojs} player
 */
export function setQuartileEvents(player) {
  const playHeadTracker = new PlayHeadTracker(0, 0, [false, false, false, false, false]);

  player.on('timeupdate', timeUpdateHandler.bind(player, playHeadTracker));
  player.on('seeked', seekedHandler.bind(player, playHeadTracker));
  player.on('ended', clearPlayHeadTracker.bind(player, playHeadTracker));
  player.on('loadedmetadata', clearPlayHeadTracker.bind(player, playHeadTracker));
  player.on('recommendationLoaded', clearPlayHeadTracker.bind(player, playHeadTracker));
}



// WEBPACK FOOTER //
// ./src/quartiles.js